import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@lohi/environments/environment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { LoHiUserInfo } from '../../root/auth.service';

export interface UploadResponseDriverNotFoundError {
  companyName: string;
  errorType: 'driver_not_found';
  errorString: string;
  driverName: string;
  trailerName: string;
  possibleDrivers:
    | null
    | {
        companyName: string;
        name: string;
        phone: string;
        userId: string;
        trailerCheckoutAt: string;
      }[];
}

export interface UploadResponseDriverNoCompanyError {
  errorType: 'driver_no_company';
  errorString: string;
  driverName: string;
  driverId: string;
}

export interface UploadResponse {
  orderId: string;
  uploaded: boolean;
  alreadyUploaded: boolean;
  hasError: boolean;
  error: string | UploadResponseDriverNotFoundError | UploadResponseDriverNoCompanyError | null;
}

@Injectable({
  providedIn: 'root',
})
export class OmmaUploadService {
  constructor(private http: HttpClient) {}

  // NOTE: need to add exception in auth-interceptor for each upload file route, otherwise it will send the wrong Content-Type
  public uploadPropx$(upload: File): Observable<UploadResponse[]> {
    const formData = new FormData();
    formData.append('file', upload);
    return this.http.post<{ results: UploadResponse[] }>(`${environment.api}/v2/propx/upload`, formData).pipe(
      map((response) => {
        return response.results;
      }),
    );
  }

  public uploadSandi$(upload: File): Observable<UploadResponse[]> {
    const formData = new FormData();
    formData.append('file', upload);
    return this.http.post<{ results: UploadResponse[] }>(`${environment.api}/v2/propx/upload_sandi`, formData).pipe(
      map((response) => {
        return response.results;
      }),
    );
  }

  public uploadEOG$(upload: File): Observable<UploadResponse[]> {
    const formData = new FormData();
    formData.append('file', upload);
    return this.http.post<{ results: UploadResponse[] }>(`${environment.api}/v2/propx/upload_eog`, formData).pipe(
      map((response) => {
        return response.results;
      }),
    );
  }

  public uploadSolaris$(upload: File): Observable<UploadResponse[]> {
    const formData = new FormData();
    formData.append('file', upload);
    return this.http.post<{ results: UploadResponse[] }>(`${environment.api}/v2/propx/upload_solaris`, formData).pipe(
      map((response) => {
        return response.results;
      }),
    );
  }

  public uploadCIG$(upload: File): Observable<UploadResponse[]> {
    const formData = new FormData();
    formData.append('file', upload);
    return this.http.post<{ results: UploadResponse[] }>(`${environment.api}/v2/propx/upload_cig`, formData).pipe(
      map((response) => {
        return response.results;
      }),
    );
  }

  public addUserNameMatching$(nameInPropX: string, userId: string): Observable<{ driver: LoHiUserInfo }> {
    return this.http.post<{ driver: LoHiUserInfo }>(`${environment.api}/v2/propx/user_name_matching`, {
      nameInPropX,
      userId,
    });
  }
}
